import ConfirmationModal from 'app/components/ConfirmationModal';

export default ConfirmationModal;
